<template>
  <v-container>
    <h2>Inserisci codice OTP ricevuto all'indirizzo</h2>
    <v-col cols="6">
      <v-text-field
        ref="input"
        label="Codice OTP"
        name="OTP"
        type="text"
        v-model="userData.otpCode"
        filled
      ></v-text-field>
    </v-col>
  </v-container>
</template>


<script>
export default {
  props: ["userData"],
  data: () => ({
    error: null,
  }),
};
</script>